import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetCouriers, GetCouriersResponse } from '../../apis/onboarding';

interface RootState {
  Couriers: CourierState;
}

export interface CourierItem {
  id: string;
  title: string;
  is_enabled: boolean;
  status: 'pending' | 'linked' | 'basic' | 'error' | null;
  is_zoom_logi_provider?: boolean;
  is_public?: boolean;
  company_courier?: string;
  instructions?: string;
  required_inputs?: string[];
}

export interface CourierState {
  courierList: CourierItem[];
  status: string | number | null;
  is_success: boolean;
  hasFetched: boolean;
}

interface CourierRejectedPayload {
  is_success?: boolean;
  status?: number;
  message?: string;
}

export const fetchAllCouriers = createAsyncThunk<
  GetCouriersResponse['data']['data'],
  string,
  { rejectValue: CourierRejectedPayload }
>('couriers/GetAllCouriers', async (token: string, thunkAPI) => {
  try {
    const response = await GetCouriers(token);
    const data = response?.data ? response?.data : null;
    if (data) {
      if (data?.data?.is_success) {
        return data?.data ? data?.data : null;
      } else {
        return thunkAPI.rejectWithValue(data?.data);
      }
    } else {
      // Reject with a generic message if the data is null or undefined
      return thunkAPI.rejectWithValue({ message: 'Unknown error occured' });
    }
  } catch (error) {
    return thunkAPI.rejectWithValue({
      message: error instanceof Error ? error.message : 'Request failed',
    });
  }
});

const courierSlice = createSlice({
  name: 'Couriers',

  initialState: {
    courierList: [],
    status: null,
    is_success: true,
    hasFetched: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCouriers.pending, (state) => {
        state.status = 'loading';
        state.hasFetched = true;
      })
      .addCase(fetchAllCouriers.fulfilled, (state, action) => {
        state.status = action?.payload?.status;
        state.courierList = Array.isArray(action?.payload?.data)
          ? action.payload.data
          : [];
        state.is_success = action?.payload?.is_success; // Populate state with fetched data
      })
      .addCase(fetchAllCouriers.rejected, (state, action) => {
        state.is_success = action?.payload?.is_success || false;
        state.status = action?.payload?.status || 'Unknown error occured';
        state.courierList = [];
        state.hasFetched = false;
      });
  },
});

//selector ref to get the state
export const selectCouriersState = (state: RootState): CourierState =>
  state.Couriers;

export const courier = courierSlice.reducer;
